import React, { useEffect, useState } from 'react'; // , { useEffect, useState }
import { useHistory } from 'react-router-dom';
import EpimedLogoImage from '../../assets/images/sponsors/logo_epimed.svg';
import LogicLogoImage from '../../assets/images/sponsors/logo_logic.svg';
import EpButton from '../../components/EpButton';
import useTranslation from '../../hooks/useTranslation';
import './styles.scss';

const SharedError = () => {
  // Tags do Globalization
  const EndorsedBy = useTranslation('Endorsed by');
  const PoweredBy = useTranslation('Powered by');
  const ErrorTitle = useTranslation('Error');
  const NotFoundMessage = useTranslation('The page you are looking for does not exist or is down.');
  const BackToTheSite = useTranslation('Back to the site');
  const AllRightsReserved = useTranslation('©2021 All rights reserved');

  const history = useHistory();

  const [statusCode, setStatusCode] = useState('');
  const [errorDescription, setErrorDescription] = useState('');

  useEffect(() => {
    if (window.history.state) {
      setStatusCode(window.history.state.state.code);
      setErrorDescription(window.history.state.state.message);
    } else {
      setStatusCode(404);
      setErrorDescription(NotFoundMessage);
    }
  }, []);

  return (
    <>
      <div id="error-page">
        <div className="container">
          <div className="error-page__introduction col-12">
            <h1 className="error-page__title col-6">
              {ErrorTitle}
              <br />
              <span className="error-page__title--highlight col-6">{statusCode}</span>
            </h1>
            <p className="error-page__description col-6">{errorDescription}</p>
            <EpButton
              actionType="button"
              customClass="col-6"
              buttonText={BackToTheSite}
              onClickFunc={() => history.push('/benchmarking')}
              buttonType="primary"
              buttonSize="lg"
              size="sm"
            />
          </div>

          {/* Bloco de Patrocinadores */}
          <footer className="error-page__footer col-12">
            <span className="error-page__copywrite">{AllRightsReserved}</span>

            <div className="sponsors error-page__sponsors">
              <ul className="sponsors__list">
                <li className="sponsors__list-item">
                  <span className="sponsors__list-item-description">{EndorsedBy}</span>
                  <a data-testid="sponsors__list-item-logo--LOGIC" href="https://www.icubenchmarking.com/" rel="noopener noreferrer" target="_blank">
                    <img className="sponsors__list-item-logo" alt="" src={LogicLogoImage} />
                  </a>
                </li>

                <li className="sponsors__list-item">
                  <span className="sponsors__list-item-description">{PoweredBy}</span>
                  <a data-testid="sponsors__list-item-logo--Epimed-Solutions" href="https://www.epimedsolutions.com/" rel="noopener noreferrer" target="_blank">
                    <img className="sponsors__list-item-logo" alt="" src={EpimedLogoImage} />
                  </a>
                </li>
              </ul>
            </div>
          </footer>
        </div>
      </div>
    </>
  );
};

export default SharedError;
